<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors/transactions'"
            >Transactions</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Update
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <transaction-form
        :activeTransactionID="activeTransactionID"
        transactionType="InvestorAccountTransaction"
        formType="update"
        @saveTransaction="updateTransaction"
      ></transaction-form>
    </div>
  </div>
</template>
<script>
import TransactionForm from "./forms/transactionForm.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
      activeTransactionID: null,
    };
  },
  created: function () {
    this.activeTransactionID = this.$route.params.transactionId;
  },
  components: {
    TransactionForm,
  },
  methods: {
    formValidation(transaction) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    updateTransaction(transaction) {
      const { isValid, message } = this.formValidation(transaction);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("updateTransaction", transaction);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      updatedTransaction: (state) =>
        state.transactionStore.transactionUpdate.updatedTransaction,
      updateTransactionStatus: (state) =>
        state.transactionStore.transactionUpdate.updateTransactionStatus,
    }),
  },
  watch: {
    updateTransactionStatus() {
      if (this.updateTransactionStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Transaction has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push(
            "/" + this.authUser.userable_type + "/investors/transactions"
          );
        });
      } else if (this.updateTransactionStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Transaction update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/updateInvestorTransaction.vue